// import { MenuOutlined, SearchOutlined, ShoppingCartOutlined } from '@ant-design/icons';
// import SignaturePad from 'react-signature-canvas';
import { sbaas } from '@/config';
import { Button, Form, Row, Slider } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import React, { Fragment, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
// import Banner from '@/assets/banner.jpeg';

type LayoutType = Parameters<typeof Form>[0]['layout'];

const RatingForm = ({ history, match }: RouteComponentProps) => {
  //consts --------------------------------
  const [isLoading, setIsLoading] = useState(false);
  const [timeOut, setTimeOut] = useState(20);
  const [formLayout, setFormLayout] = useState<LayoutType>('vertical');
  const [form] = Form.useForm();
  const [ratingService, setRatServ] = useState<any>(7);
  const [ratingRecom, setRatRec] = useState<any>(10);
  // const [notifCantSubmit, setNotifCantSubmit] = React.useState(false);

  var token: Headers = new Headers();
  let data = match.params['data'];

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  const satisfaction = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
  };

  const recommendation = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
  };

  const submitRating = async () => {
    // if (!checkAllMandatoryFields()) {
    //   setNotifCantSubmit(true);
    //   return;
    // }

    let key: string | any = localStorage.getItem('token');

    token.append('x-sb-token', key);

    try {
      await sbaas
        .script('post_rating_form')
        .post({
          headers: token,
          body: {
            qr_value: data,
            rating_service: ratingService,
            rating_recommendation: ratingRecom,
          },
        })
        .then(res => {
          console.log('res: ', res);
          window.location.reload();
        });
    } catch (error) {}
  };
  // console.log(ratingRecom);
  // const checkAllMandatoryFields = () => {
  //   if (ratingService === undefined || ratingRecom === undefined) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  //functions --------------------------------

  // function onChangeR(e: any) {
  //   console.log('checkedR = ', e);
  //   setValue(e.target.value);
  // }

  //hooks (useEffect) --------------------------------

  useEffect(() => {
    if (isLoading) {
      const count: any =
        timeOut > 0 &&
        setInterval(() => {
          setTimeOut(timeOut - 1);
        }, 1000);
      if (count < 1) setIsLoading(false);
      return () => clearInterval(count);
    }
    return;
  }, [timeOut, isLoading]);

  const onClickContactService = () => {
    history.replace('/contact-service');
  };

  return (
    <Fragment>
      <Header style={{ backgroundColor: 'white' }} className="header">
        <div className="logo" />
      </Header>

      <Row>
        <div className="header-banner"></div>
        <div className="submit-form-content">
          <span
            style={{
              fontFamily: 'Samsung Sharp Sans Bold',
              color: '#000000',
              margin: '15px 0 6px 0',
              display: 'block',
              fontSize: '14px',
            }}
          >
            Survey Pelanggan
            <span style={{ color: '#FF2020' }}>*</span>
          </span>

          <Form
            layout={formLayout}
            form={form}
            initialValues={{ layout: formLayout }}
            onValuesChange={onFormLayoutChange}
          >
            <Form.Item>
              <Slider
                marks={satisfaction}
                min={1}
                max={7}
                defaultValue={ratingService}
                onChange={e => setRatServ(e)}
              />
              {console.log(typeof localStorage.getItem('token'))}
              <div className="slider-desc">
                <span>Sangat Tidak Puas</span>
                <span>Sangat Puas</span>
              </div>
            </Form.Item>

            <Form.Item
              label={
                <span style={{ fontFamily: 'Samsung Sharp Sans Bold' }}>
                  Apakah Anda merekomendasikan produk SAMSUNG kepada teman dan
                  keluarga?<span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Slider
                marks={recommendation}
                min={1}
                max={10}
                defaultValue={ratingRecom}
                onChange={e => setRatRec(e)}
              />
              {console.log(ratingRecom, ratingService)}
              <div className="slider-desc">
                <span>Sangat Tidak Merekomendasikan</span>
                <span>Sangat Merekomendasikan</span>
              </div>
            </Form.Item>

            <Form.Item
              style={{ textAlign: 'center' }}
              // help={
              //   !notifCantSubmit ? (
              //     ''
              //   ) : (
              //     <span style={{ color: '#FF2020', fontSize: '10px' }}>
              //       Kolom yang wajib diisi tidak boleh kosong
              //     </span>
              //   )
              // }
            >
              <Button
                className="submit-form-button"
                type="primary"
                onClick={submitRating}
              >
                Kirim Rating
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Row>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button
          onClick={onClickContactService}
          style={{ background: 'none', border: 'none' }}
        >
          <p style={{ color: 'grey', textDecoration: 'underline' }}>
            Contact Service
          </p>
        </Button>
      </Form.Item>
    </Fragment>
  );
};

export default RatingForm;
